module.exports = __webpack_public_path__ + "static/media/Poppins-Bold.55831c59.ttf";